import React from 'react';
import './style.scss';

/**
 * PageTitle component.
 *
 * @param {Object} props - Props for the PageTitle component.
 * @param {string} props.title - The title text.
 * @returns {JSX.Element} The PageTitle component.
 * @example
 *  <PageTitle title={t("needsTitle")} />
 */
function PageTitle({ title }) {
    return (
        <span className="page-title ml-20">{title}</span>
    );
}

PageTitle.defaultProps = {
    title: ''
};

export default PageTitle;